import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

//Import Pages
import AboutPage from './pages/AboutPage/AboutPage';
import ValuesPage from './pages/ValuesPage/ValuesPage';
import ServicePage from './pages/ServicePage/ServicePage';
import HomePage from './pages/HomePage/HomePage';
import ContactPage from './pages/ContactPage/ContactPage';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/values" element={<ValuesPage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path='/contact-us' element={<ContactPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
